import styled, { css } from "styled-components"
import InputField from "./InputField"
import { FaTimesCircle } from "react-icons/fa";
import theme from "../../UI/theme";
import { useRef } from "react";

const Container = styled.div`
    position: relative;
    height: fit-content;
`

const ClearIcon = styled(FaTimesCircle)`
    color: ${theme.colors.textGray};
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    ${props => props.disabled && css`
        opacity: 0.2;
        cursor: initial;
    `}
`

const SearchField = props => {
    const inputRef = useRef();

    const clearSearchField = () => {
        if (inputRef.current) {
            const setValue = Object.getOwnPropertyDescriptor(inputRef.current.__proto__, 'value').set;
            const event = new Event('input', { bubbles: true });

            setValue.call(inputRef.current, '');
            inputRef.current.dispatchEvent(event);
            inputRef.current.focus();
        }
    }

    return <Container>
        <InputField ref={inputRef} {...props} />
        <ClearIcon disabled={props.disabled} onClick={() => clearSearchField()} />
    </Container>
}

export default SearchField;